import { render, staticRenderFns } from "./SolutionTeaser.vue?vue&type=template&id=5433553c&scoped=true"
import script from "./SolutionTeaser.vue?vue&type=script&lang=js"
export * from "./SolutionTeaser.vue?vue&type=script&lang=js"
import style0 from "./SolutionTeaser.vue?vue&type=style&index=0&id=5433553c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5433553c",
  null
  
)

export default component.exports